import { call, takeLatest, put } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchGoalAnalytics } from 'api/IterableGoalsAPI';

import { Saga } from 'custom-types/saga';
import { GoalAnalyticsAction, GoalAnalyticsQuery } from 'modules/iterableGoals/types';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { getCommonTranslations } from 'utils/translations';
import * as actions from 'modules/iterableGoals/ducks/actions';
import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';

// Temporary caching mechanism
const cachedQueryData: Record<string, string | undefined> = {
  startTime: '',
  endTime: '',
};

export function* fetchGoalAnalyticsSaga({
  queryData,
}: GoalAnalyticsAction<{
  queryData: GoalAnalyticsQuery;
}>): Saga<GoalAnalyticsAction> {
  try {
    let responseData = {};
    const hasTimeRangeChanged =
      cachedQueryData.startTime !== queryData.startTime ||
      cachedQueryData.endTime !== queryData.endTime;

    if (hasTimeRangeChanged) {
      const { data } = yield call(fetchGoalAnalytics, queryData);

      // Updating the time range in the redux state
      cachedQueryData.startTime = queryData?.startTime;
      cachedQueryData.endTime = queryData?.endTime;
      responseData = data;
    }
    yield put(actions.fetchGoalAnalyticsResponse(responseData));
  } catch (error) {
    const errorMessage = yield call(getCommonTranslations, 'errorMessage.contactCSM');
    yield put(actions.fetchGoalAnalyticsError());
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          source: 'fetchGoalAnalyticsSaga',
          error,
          additional: queryData,
        }),
      ),
    );
  }
}

addToRootSaga([takeLatest(ActionTypes.FETCH_GOAL_ANALYTICS_REQUEST, fetchGoalAnalyticsSaga)]);
